import React, { useState } from "react";
import axios from "axios";

const urlParams = new URLSearchParams(window.location.search);
const trainer = urlParams.get("t");
let loadOnce = 0;

function getPokedex(t) {
  return axios.get(`./api/pokedex/${t}`);
}

function Pokedex() {
  const [normal, setNormal] = useState([]);
  const [shiny, setShiny] = useState([]);

  if (loadOnce < 2) {
    loadOnce++;
    getPokedex(trainer).then(async ({ data }) => {
      const temp = { ...data };
      // get normal pokemon details
      for (let i = 0; i < data.normal.length; i++) {
        const p = data.normal[i]
        let data2;
        if (p.name === "Nidoran♀") {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/nidoran-f`);
        } else if (p.name === "Nidoran♂") {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/nidoran-m`);
        }
        else if (p.name === "Enamorus") {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/enamorus-incarnate`);
        } else {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${p.name.toLowerCase()}`);
        }
        const { data: pokemon } = data2;
        const img = pokemon.sprites.other.home.front_default;
        const { data: species } = await axios.get(pokemon.species.url);
        const { flavor_text } = species["flavor_text_entries"].find(a => a.language.name === "en");
        const flavor = flavor_text.replaceAll("\f", " ").replaceAll("\n", " ");
        temp.normal[i].img = img;
        temp.normal[i].flavor = flavor;
      }
      setTimeout(() => { setNormal([...temp.normal]); }, 1000);
      // get shiny pokemon details

      for (let i = 0; i < data.shiny.length; i++) {
        const p = data.shiny[i]
        let data2;
        if (p.name === "Nidoran♀") {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/nidoran-f`);
        } else if (p.name === "Nidoran♂") {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/nidoran-m`);
        } else {
          data2 = await axios.get(`https://pokeapi.co/api/v2/pokemon/${p.name.toLowerCase()}`);
        }
        const { data: pokemon } = data2;
        const img = pokemon.sprites.other.home.front_shiny;
        const { data: species } = await axios.get(pokemon.species.url);
        const { flavor_text } = species["flavor_text_entries"].find(a => a.language.name === "en");
        const flavor = flavor_text.replaceAll("\f", " ").replaceAll("\n", " ");
        temp.shiny[i].img = img;
        temp.shiny[i].flavor = flavor;

        setTimeout(() => { setShiny([...temp.shiny]); }, 1000);
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function showInfo(e) {
    const target = e.target.dataset.name;
    const info = document.querySelector(`#${target}`);
    info.style.display = "block";
  }

  function hideInfo(e) {
    const target = e.target.dataset.name;
    const info = document.querySelector(`#${target}`)
    info.style.display = "none";
  }

  return (
    <div id="main">
      <h1>Hello, {trainer}!</h1>
      <p>Here are your stats for the Pokémon Chat Game!</p>
      <div className="pokedex flex-row">
        <h2>Total Pokémon: {normal.length + shiny.length}</h2>
      </div>
      <div className="pokedex flex-row">
        <h2>Common Pokémon</h2>
        <div className="normal half">
          <h3>Normal (Total: {normal.filter(p => p.legendary === false).length})</h3>
          <hr />
          <div className="flex-col">
            {normal.filter(p => p.legendary === false).map(p => {
              return (
                <div className="name" key={p.name}>
                  <span>{p.name}</span> <span className="icon" data-name={p.name} onClick={showInfo}>🛈</span>
                  <div className="backdrop" id={p.name} data-name={p.name} onClick={hideInfo}>
                    <span>Click Anywhere To Close</span>
                    <div className="details">
                      <span className="close">&times;</span>
                      <div className="bg-yellow">{p.name}</div>
                      <div className="border">
                        <img src={p.img} alt={p.name} />
                        <p>{p.flavor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="shiny half">
          <h3>Shiny (Total: {shiny.filter(p => p.legendary === false).length})</h3>
          <hr />
          <div className="flex-col">
            {shiny.filter(p => p.legendary === false).map(p => {
              return (
                <div className="name" key={p.name}>
                  <span>{p.name}</span> <span className="icon" data-name={p.name + "-shiny"} onClick={showInfo}>🛈</span>
                  <div className="backdrop" id={p.name + "-shiny"} data-name={p.name + "-shiny"} onClick={hideInfo}>
                    <span>Click Anywhere To Close</span>
                    <div className="details">
                      <span className="close">&times;</span>
                      <div className="bg-yellow">{p.name}</div>
                      <div className="border">
                        <img src={p.img} />
                        <p>{p.flavor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="pokedex flex-row">
        <h2>Legendary Pokémon</h2>
        <div className="normal half">
          <h3>Normal (Total: {normal.filter(p => p.legendary === true).length})</h3>
          <hr />
          <div className="flex-col">
            {normal.filter(p => p.legendary === true).map(p => {
              return (
                <div className="name" key={p.name}>
                  <span>{p.name}</span> <span className="icon" data-name={p.name} onClick={showInfo}>🛈</span>
                  <div className="backdrop" id={p.name} data-name={p.name} onClick={hideInfo}>
                    <span>Click Anywhere To Close</span>
                    <div className="details">
                      <span className="close">&times;</span>
                      <div className="bg-yellow">{p.name}</div>
                      <div className="border">
                        <img src={p.img} alt={p.name} />
                        <p>{p.flavor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="shiny half">
          <h3>Shiny (Total: {shiny.filter(p => p.legendary === true).length})</h3>
          <hr />
          <div className="flex-col">
            {shiny.filter(p => p.legendary === true).map(p => {
              return (
                <div className="name" key={p.name}>
                  <span>{p.name}</span> <span className="icon" data-name={p.name + "-shiny"} onClick={showInfo}>🛈</span>
                  <div className="backdrop" id={p.name + "-shiny"} data-name={p.name + "-shiny"} onClick={hideInfo}>
                    <span>Click Anywhere To Close</span>
                    <div className="details">
                      <span className="close">&times;</span>
                      <div className="bg-yellow">{p.name}</div>
                      <div className="border">
                        <img src={p.img} />
                        <p>{p.flavor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div >
  )
}

export default Pokedex;